export default {
    skeletonCircle: {
        marginLeft: 'auto',
        marginRight: 'auto',
    },
};
